/** Permit-related email triggers (must match backend permitRiderEmailTriggers.cjs). */

export const PERMIT_RIDER_EMAIL_TRIGGER_DEFINITIONS = [
  {
    id: "permit_rider_added",
    label: "Permit rider / amendment added",
    group: "Permits",
  },
];
